// client/src/components/Admin/Dashboard/_shared/AnalyticsWidget.js
//
// M06 Fase 4 + ext - Widget compacto de analitica de uso para una vertical.
// Muestra 3 mini-KPIs: visitas, sesiones, tiempo medio. Indica el modo
// activo (general vs plataforma) en lugar del badge "Datos simulados".

import React from "react";
import styles from "./AnalyticsWidget.module.scss";

function formatNumber(n) {
  if (n === null || n === undefined) return "-";
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
  return String(n);
}

const MODE_LABELS = {
  general: "Vista general",
  platform: "Vista plataforma",
};

export function AnalyticsWidget({ title = "Analitica de uso", usage }) {
  if (!usage || !usage.totals) return null;

  const { visits, sessions, avgSessionMinutes } = usage.totals;
  const mode = usage.mode || "general";
  const modeLabel = MODE_LABELS[mode] || mode;

  return (
    <div className={styles.analyticsWidget}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>
        <span className={styles.badge}>{modeLabel}</span>
      </div>
      <div className={styles.miniKpis}>
        <div className={styles.miniKpi}>
          <div className={styles.miniLabel}>Visitas</div>
          <div className={styles.miniValue}>{formatNumber(visits)}</div>
        </div>
        <div className={styles.miniKpi}>
          <div className={styles.miniLabel}>Sesiones</div>
          <div className={styles.miniValue}>{formatNumber(sessions)}</div>
        </div>
        <div className={styles.miniKpi}>
          <div className={styles.miniLabel}>Tiempo medio</div>
          <div className={styles.miniValue}>
            {avgSessionMinutes ? `${avgSessionMinutes} min` : "-"}
          </div>
        </div>
      </div>
    </div>
  );
}
